import { WorkspaceSettingsPages } from "@components/settings/constants";
import { useSettings } from "@components/settings/SettingsProvider";
import { NavNotice } from "@design-system/NavNotice/NavNotice";
import { usePendingOrgBillingTransfer } from "./usePendingOrgBillingTransfer";

/**
 * The "Set up billing" notice for the recipient of a pending org billing
 * transfer. Takes the billing chip's place in an open workspace nav and opens
 * the Billing settings page, which carries the accept and decline actions; a
 * mini nav has no room for it, so the Billing settings page carries the CTA
 * there.
 */
export const useInlineOrgBillingTransferNotice = () => {
    const request = usePendingOrgBillingTransfer();
    const { open } = useSettings();

    if (!request) {
        return null;
    }

    return (
        <NavNotice
            label="Set up billing"
            hint={`Open billing settings to accept the transfer from ${request.organizationName}`}
            onClick={() => open([WorkspaceSettingsPages.BILLING_TRANSFER])}
        />
    );
};
